var map = {
	"./reference+form.pdf": 384,
	"./碩_入學考試_選考科目建議閱讀書單.pdf": 385,
	"./碩士推甄簡章_110.pdf": 386,
	"./碩士班_課程修習及學位考試規定_1060111.pdf": 387,
	"./碩士考試招生簡章_110.pdf": 388,
	"./臺大語言所碩士班入學考試選考科目建議閱讀書單20200721.docx": 389,
	"./臺大語言所碩士班入學考試選考科目建議閱讀書單20200721.pdf": 390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;